import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider.jsx";

export default function UserDashboard() {
    const { user } = useAuth();

    const displayName =
        user?.display_name ||
        user?.discord_username ||
        user?.email ||
        "User";

    return (
        <div className="card">
            <h1>Userbereich</h1>

            <p className="muted">
                Willkommen, {displayName}. Hier entsteht dein persönlicher RaceVision Bereich.
            </p>

            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 18 }}>
                <Link className="btn" to="/manager/user/profile">
                    Profil öffnen
                </Link>

                <Link className="btn" to="/manager/user/registrieren">
                    Registrieren
                </Link>
            </div>
        </div>
    );
}